import { MooringCategoryType } from './MooringArticleCategoryType';
import { ArticleTypeVariant } from './MooringArticleType';

export class CreateMooringTemplateDto {
  Name: string;
  Components: CreateMooringComponentTemplateEntryDto[];
}

export class CreateMooringComponentTemplateEntryDto {
  ArticleProductId: number;
  HasLoadConstraint: boolean;
  SortIndex: number;
}

export class UpdateMooringTemplateDto {
  Id: number;
  Name: string;
  Components: UpdateMooringComponentTemplateEntryDto[];
}

export class UpdateMooringComponentTemplateEntryDto extends CreateMooringComponentTemplateEntryDto {
  Id?: number;
}

export class MooringTemplateListItemDto {
  Id: number;
  Name: string;
  CreatedBy: string;
  Created: Date;
}

export class MooringTemplateDto {
  Id: number;
  Name: string;
  CreatedBy: string;
  Created: Date;
  Components: MooringComponentTemplateEntryDto[];
}

export class MooringComponentTemplateEntryDto {
  Id: number;

  ArticleProductId: number;
  ProductName: string;

  HasLoadConstraint: boolean;
  HasKnot: boolean;

  CategoryName: string;
  TypeName: string;
  ProductTypeName?: string;

  IsForCounterWeight: boolean;

  Quantity: number;

  MBL?: number;
  WLL?: number;

  SortIndex: number;

  CategoryType: MooringCategoryType;
  TypeVariant: ArticleTypeVariant;

  PrimaryDimension: number;
  SecondaryDimension?: number;
}
